import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 px-6 py-32">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <h1 className="text-4xl font-bold text-center mb-6">
          SphereX Privacy Policy & Terms of Service
        </h1>
        <p className="text-center text-lg text-gray-600 mb-10">
          Convert your Crypto & Gift cards to Naira with ease. Get paid fast when you sell your crypto & gift cards on SphereX.
        </p>

        {/* Sections */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
          <p>
            At <strong>SphereX</strong>, your privacy and digital asset security are fundamental to our services.  
            This Privacy Policy explains how we collect, use, store, and protect your personal information when you trade cryptocurrency and convert gift cards into automated fiat Naira deposits.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">2. Information We Collect</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Account Identity:</strong> Full name, username, email address, and phone number.</li>
            <li><strong>Financial Credentials:</strong> Verified Nigerian bank account numbers and recipient names for automated payouts.</li>
            <li><strong>Identity Verification (KYC):</strong> Government IDs (NIN, BVN, Driver's License, International Passport) submitted for Anti-Money Laundering (AML) compliance.</li>
            <li><strong>Trade Data:</strong> Crypto wallet transaction details, gift card images/codes, trade timestamps, and support chat records.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">3. How We Use Your Information</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>To verify identity and execute instant fiat bank transfers for trade payouts.</li>
            <li>To validate gift card authenticity and prevent fraudulent double redemptions.</li>
            <li>To enforce account security, rate calculations, and send real-time login & trade notifications.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">4. Data Protection & Encryption</h2>
          <p>
            We deploy 256-bit SSL encryption across all web and mobile client endpoints. User passwords are stored strictly using salted bcrypt hashing algorithms. We never sell or share user data with third-party advertisers.
          </p>
        </section>

        <section className="mb-8 border-l-4 border-red-500 pl-4 py-2 bg-red-50/50 rounded-r-xl">
          <h2 className="text-2xl font-semibold mb-3 text-red-900">5. Account Deletion & Danger Zone (Data Rights)</h2>
          <p className="mb-3">
            SphereX respects your right to complete data control. Users can request account deletion at any time through the <strong>Account Settings Danger Zone</strong> in both our Web and Mobile applications.
          </p>
          <ul className="list-disc ml-6 space-y-2 text-red-950 text-sm">
            <li><strong>Immediate Removal:</strong> Account credentials, saved bank accounts, and active login tokens are permanently removed from our active database upon deletion confirmation.</li>
            <li><strong>Audit Logs:</strong> Historical transaction records are retained in compliance with statutory financial audit and AML regulatory mandates.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">6. Terms of Service & Gift Card Rules</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Trade payouts are processed automatically to the user's primary verified bank account.</li>
            <li>Users must submit valid, legally acquired gift cards. Fraudulent submissions result in immediate account termination.</li>
            <li>Email address and Phone number updates require Admin identity verification for security protection.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">7. Contact Us</h2>
          <p>
            If you have any questions regarding this Privacy Policy or wish to submit an account modification/deletion request, please contact our 24/7 team at:  
            <a
              href="mailto:support@thespherex.com"
              className="text-blue-600 underline font-semibold ml-1"
            >
              support@thespherex.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
